module.exports = __webpack_public_path__ + "static/img/banner-mobile23.5e27195.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner-mobile23.jpg
// module id = REPx
// module chunks = 1